import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: (resolve) => require(['@/page/login/login'], resolve)
  },
  {
    path: '/view',
    component: (resolve) => require(['@/page/view/view'], resolve),
    name: '',
    children: [
      {
        path: '',
        component: (resolve) => require(['@/page/home/home'], resolve),
        meta: []
      },
      {
        path: '/overallStatus',
        component: (resolve) => require(['@/page/overallStatus/overallStatus'], resolve)
      },
      {
        path: '/reportCenter',
        component: (resolve) => require(['@/page/reportCenter/reportCenter'], resolve),
        meta: []
      },
      {
        path: '/qualityBalance',
        component: (resolve) => require(['@/page/qualityBalance/qualityBalance'], resolve),
        meta: []
      },
      {
        path: '/baseBalance',
        component: (resolve) => require(['@/page/baseBalance/baseBalance'], resolve),
        meta: []
      },
      {
        path: '/midwestEducation',
        component: (resolve) => require(['@/page/midwestEducation/midwestEducation'], resolve),
        meta: []
      },
      {
        path: '/sportsWork',
        component: (resolve) => require(['@/page/sportsWork/sportsWork'], resolve),
        meta: []
      },
      {
        path: '/ranking',
        component: (resolve) => require(['@/page/ranking/ranking'], resolve),
        meta: []
      },
      {
        path: '/disparity',
        component: (resolve) => require(['@/page/disparity/disparity'], resolve),
        meta: []
      },
      {
        path: '/development',
        component: (resolve) => require(['@/page/development/development'], resolve),
        meta: []
      },
      {
        path: '/hotspot',
        component: (resolve) => require(['@/page/hotspot/hotspot'], resolve),
        meta: []
      },
      {
        path: '/dataRecord',
        component: (resolve) => require(['@/page/dataRecord/dataRecord'], resolve),
        meta: []
      },
      {
        path: '/dataRecordDetail',
        name: '看数字查看详情',
        component: (resolve) => require(['@/page/dataRecord/dataRecordDetail'], resolve),
        meta: []
      },
      {
        path: '/queryDetail',
        component: (resolve) => require(['@/page/queryDetail/queryDetail'], resolve),
        meta: []
      },
      {
        path: '/countyDataManagement',
        component: (resolve) => require(['@/page/countyDataManagement/countyDataManagement'], resolve),
        meta: []
      },
      {
        path: '/dataAudit',
        component: (resolve) => require(['@/page/dataAudit/dataAudit'], resolve),
        meta: []
      },
      {
        path: '/userManagement',
        component: (resolve) => require(['@/page/userManagement/userManagement'], resolve),
        meta: []
      }
    ]
  }
]

export default new Router({
  routes,
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/router/index.js